import { jsx as _jsx } from "react/jsx-runtime";
import NukaCarousel from 'nuka-carousel';
import { useState } from 'react';
import { useBreakpoint } from "../../theme/src";
import { SliderArrow } from './components/SliderArrow';
import { INFINITE_SLIDER_ITEMS_PER_PAGE_DEFAULT } from './constants';
const Carousel = NukaCarousel.default
    ?
        NukaCarousel.default
    : NukaCarousel;
export const InfiniteSlider = ({ ItemComponent, cellAlign = 'center', infinite = true, items = [], perPageBreakpoints = INFINITE_SLIDER_ITEMS_PER_PAGE_DEFAULT, showDots = () => null, }) => {
    const [activeItem, setActiveItem] = useState(0);
    const breakpoint = useBreakpoint();
    const handleActiveItem = (_currentSlideIndex, endSlideIndex) => setActiveItem(endSlideIndex);
    const perPage = perPageBreakpoints[breakpoint];
    return (_jsx(Carousel, { beforeSlide: handleActiveItem, cellAlign: cellAlign, disableEdgeSwiping: true, renderBottomCenterControls: showDots, renderCenterLeftControls: ({ previousSlide }) => (_jsx(SliderArrow, { isPrev: true, onClick: previousSlide })), renderCenterRightControls: ({ nextSlide }) => (_jsx(SliderArrow, { onClick: nextSlide })), slidesToShow: perPage, wrapAround: infinite, children: items === null || items === void 0 ? void 0 : items.map((item, index) => (_jsx(ItemComponent, Object.assign({}, item, { activeItem: activeItem, index: index }), item.id))) }));
};
//# sourceMappingURL=InfiniteSlider.js.map